import { render } from "./agent-workflow.vue?vue&type=template&id=5a13f2aa"
import script from "./agent-workflow.js?vue&type=script&lang=js"
export * from "./agent-workflow.js?vue&type=script&lang=js"

import "./agent-workflow.vue?vue&type=style&index=0&id=5a13f2aa&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__